import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'
import { sortByEventTime } from 'lib/utils/store/event'
import { CurrencyFormatter } from 'lib/utils/currency'

import VehicleFuelConsumptionRefills from 'components/Vehicles/VehicleFuelConsumption/VehicleFuelConsumptionRefills/VehicleFuelConsumptionRefills'

import './vehicle-fuel-consumption-display.pcss'

const VehicleFuelConsumptionDisplay = ({ t, fuelConsumption, vehicleId, onBackToEdit }) => {
    const {
        consumption,
        distanceDriven,
        litersConsumed,
        totalPrice,
        averagePrice,
        refillEvents,
        startDate,
        endDate
    } = fuelConsumption

    refillEvents.sort(sortByEventTime(moment))

    const startTime = moment(startDate).format('DD.MM.YYYY')
    const endTime = moment(endDate).format('DD.MM.YYYY')

    return (
        <div className="vehicle-fuel-consumption-display">
            <h2>{t('vehicles:fuelConsumption.title')}</h2>
            <div className="vehicle-fuel-consumption-display__description">
                {t('vehicles:fuelConsumption.description')}
            </div>
            <div className="vehicle-fuel-consumption-display__time-range">
                {`${startTime} - ${endTime}`}
            </div>
            <div className="vehicle-fuel-consumption-display__avg-consumption">
                {`${Math.round(consumption * 100) / 100} `}<span>{t('vehicles:fuelConsumption.litersPer100km')}</span>
            </div>
            <table className="vehicle-fuel-consumption-display__data-table">
                <tbody>
                    <tr>
                        <td>{t('vehicles:fuelConsumption.data.distance')}</td>
                        <td>{distanceDriven} km</td>
                    </tr>
                    <tr>
                        <td>{t('vehicles:fuelConsumption.data.litersConsumed')}</td>
                        <td>{litersConsumed} l</td>
                    </tr>
                    <tr>
                        <td>{t('vehicles:fuelConsumption.data.price')}</td>
                        <td>{CurrencyFormatter.format(totalPrice)}</td>
                    </tr>
                    <tr>
                        <td>{t('vehicles:fuelConsumption.data.avgLiterPrice')}</td>
                        <td>{CurrencyFormatter.format(averagePrice)}</td>
                    </tr>
                </tbody>
            </table>
            <VehicleFuelConsumptionRefills
                vehicleId={vehicleId}
                refillEvents={refillEvents}
                onBackToEdit={onBackToEdit}
            />
        </div>
    )
}

VehicleFuelConsumptionDisplay.propTypes = {
    fuelConsumption: PropTypes.object.isRequired,
    vehicleId: PropTypes.string.isRequired,
    onBackToEdit: PropTypes.func,
}

export default flowRight(
    withTranslationCustom(['formElements', 'vehicles']),
)(VehicleFuelConsumptionDisplay)
